
import ApplicationStartStep from "./ApplicationStartStep";
import AwardsStep from "./AwardsStep";
import BioStep from "./BioStep";
import DisciplineSkillsStep from "./DisciplineSkillsStep";
import EducationStep from "./EducationStep";
import IndustriesStep from "./IndustriesStep";
import LinksDocumentsStep from "./LinksDocumentsStep";
import InfoStep from "./InfoStep";
import BrandsStep from "./BrandsStep";
import ReferencesStep from "./ReferencesStep";
import WorkSamplesStep from "./WorkSamplesStep";
import ProjectInterestsStep from "./ProjectInterestsStep";
import VideoInterviewStep from "./VideoInterviewStep";
import ReviewStep from "./ReviewStep";
import WorkHistoryStep from "./WorkHistoryStep";
import RecommendedSkillsStep from './RecommendedSkillsStep'
import AIExperienceStep from "./AIExperienceStep";

export {
    ApplicationStartStep,
    AwardsStep,
    BioStep,
    DisciplineSkillsStep,
    RecommendedSkillsStep,
    EducationStep,
    BrandsStep,
    ReferencesStep,
    IndustriesStep,
    LinksDocumentsStep,
    InfoStep,
    WorkSamplesStep,
    ProjectInterestsStep,
    ReviewStep,
    VideoInterviewStep,
    WorkHistoryStep,
    AIExperienceStep,
};
